<template>
  <div>
    <div class="w-full">
      <div ref="wrapperRef" class="rounded-[10px] overflow-hidden">
        <transition
          enter-active-class="duration-300 ease-in-out absolute inset-0"
          enter-from-class="opacity-0"
          enter-to-class="opacity-100"
          leave-active-class="duration-300 ease-in-out absolute inset-0"
          leave-from-class="opacity-100"
          leave-to-class="opacity-0"
        >
          <div v-if="!isHovered || !hasSocialMediaLink">
            <RetinaImage
              width="212px"
              height="240px"
              responsive="2x"
              :src="item.img"
              alt="avatar"
              class="w-full h-full object-cover"
            />
          </div>

          <div v-else class="bg-blue-900 h-full flex items-center justify-center">
            <div class="flex">
              <a
                v-if="item.facebook"
                :href="item.facebook"
                class="w-10 h-10 rounded-full flex items-center justify-center bg-blue-700 mr-3 last:mr-0"
              >
                <Icon name="facebook-stroke" class="w-4 h-4 text-white" />
              </a>
              <a
                v-if="item.twitter"
                :href="item.twitter"
                class="w-10 h-10 rounded-full flex items-center justify-center bg-blue-700 mr-3 last:mr-0"
              >
                <Icon name="twitter" class="w-4 h-4 text-white" />
              </a>
              <a
                v-if="item.instagram"
                :href="item.instagram"
                class="w-10 h-10 rounded-full flex items-center justify-center bg-blue-700 mr-3 last:mr-0"
              >
                <Icon name="instagram" class="w-4 h-4 text-white" />
              </a>
            </div>
          </div>
        </transition>
      </div>
    </div>
    <div class="mt-3.5 flex flex-col">
      <strong class="text-gray-900 text-lg font-semibold">{{ item.name }}</strong>
      <span v-if="item.position" class="text-gray-300 text-[0.8125rem] leading-4 mt-1.5 font-semibold uppercase">{{
        item.position
      }}</span>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { PropType } from 'vue'
import { TeamItemType } from '~/types/team-types'

const props = defineProps({
  item: {
    type: Object as PropType<TeamItemType>,
    required: true,
  },
})

const hasSocialMediaLink = computed(() => !!(props.item.facebook || props.item.instagram || props.item.twitter))

const wrapperRef = ref()
const isHovered = useElementHover(wrapperRef, { delayEnter: 100, delayLeave: 100 })
onClickOutside(wrapperRef, () => (isHovered.value = false))
</script>
